<template>
  <!-- 可复用图书卡片组件 -->
  <div class="book-card" @click="goBookDetail">
    <div class="book-card-ms-icon" v-if="showMsPromotionIcon">
      <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/boolMall/ms-icon.png" />
    </div>
    <div class="book-card-cover">
      <img :src="coverUrl" alt="" />
      <div class="author-tag">
        <span class="author-name">{{ displayAuthorName }}</span>
      </div>
    </div>
    <div class="book-card-info">
      <div class="book-name ellipsis">{{ displayBookName }}</div>
      <div v-if="displayBookDesc" class="book-desc">
        <div v-if="isBookDescRichText" class="book-desc__inner" v-html="displayBookDesc"></div>
        <div v-else class="book-desc__inner">{{ displayBookDesc }}</div>
      </div>
      <div class="course_discount">
        <span v-if="item.isUnionDiscount">联报优惠</span>
        <span v-if="item.isFullDiscount">满减优惠</span>
        <span v-if="item.isCouponDiscount">优惠券</span>
      </div>
      <div class="book-price-info">
        <span
          class="courseType"
          v-if="
            item.productDiscountRespVO &&
            item.productDiscountRespVO.isGroupDiscount &&
            !showMsPromotionIcon
          "
          >拼团价</span
        >
        <span v-else-if="item.promotionLabel && !showMsPromotionIcon" class="courseType">{{
          item.promotionLabel === 1 ? '折后价' : item.promotionLabel === 4 ? '券后价' : '限时价'
        }}</span>
        <span class="courseType" v-else-if="!item.promotionLabel &&!item.sellPrice"
          >免费</span
        >
        <div class="showPic" :class="{ 'showPic--ms': showMsPromotionIcon }">
          <template v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount">
            <b>¥</b>
            <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
          </template>
          <template v-else>
            <template v-if="item.promotionLabel || item.sellPrice">
              <b>¥</b>
              <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
                item.sellPrice
              }}</span>
            </template>
          </template>
        </div>
        <s v-if="item.originalPrice">{{ item.originalPrice }}</s>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookCard',
  props: {
    // 书卡完整数据
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    coverUrl() {
      const bookCover = this.item.productBookInfoVO?.bookCover;
      return bookCover || this.item.coverMobile || '';
    },
    displayAuthorName() {
      const teacherNames = (this.item.teacherRespVOS || this.item.teacherRespVOList||[])
        .map((teacher) => teacher?.name)
        .filter(Boolean)
        .join('、');
      return teacherNames;
    },
    displayBookName() {
      if (this.item.setType === 1) {
        return this.item.name;
      }
      return this.item.productBookInfoVO?.bookName || this.item.name;
    },
    displayBookDesc() {
      if (this.item.setType === 1) {
        return '该图书为组合套餐，进入查看详情吧~';
      }
      return this.item.productBookInfoVO?.bookIntroduction;
    },
    /** bookIntroduction 可能为纯文本或带 HTML 标签的富文本 */
    isBookDescRichText() {
      const raw = this.displayBookDesc;
      if (raw == null || typeof raw !== 'string') return false;
      const s = raw.trim();
      if (!s) return false;
      return /<\/?[a-z][\s\S]*>/i.test(s);
    },
    showMsPromotionIcon() {
      const label = this.item.promotionLabel;
      return label === 2 || label === 3;
    },
  },
  methods: {
    goBookDetail() {
      this.$emit('click', this.item); // 触发父组件点击事件
    },
  },
};
</script>

<style lang="scss" scoped>
.book-card {
  position: relative;
  display: flex;
  height: 272px;
  padding: 36px 29px;
  background: #fff;
  border-radius: 14px;
  cursor: pointer;

  .book-card-ms-icon {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 101px;
    height: 36px;
    overflow: hidden;
    background: #ffd759;
    border-radius: 0 14px 0 14px;

    img {
      display: block;
      width: 80px;
      max-width: 100%;
      height: 25px;
      max-height: 100%;
      object-fit: contain;
      pointer-events: none;
    }
  }

  .book-card-cover {
    position: relative;
    flex-shrink: 0;
    width: 150px;
    height: 199px;
    border-radius: 7px;
    img {
      width: 145px;
      height: 192px;
      border-radius: 14px;
    }

    .author-tag {
      position: absolute;
      bottom: 9px;
      left: 7px;
      max-width: 131px;
      .author-name {
        display: block;
        height: 29px;
        padding: 1px 7px;
        overflow: hidden;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        line-height: 29px;
        white-space: nowrap;
        text-align: center;
        text-overflow: ellipsis;
        background: rgba(31, 32, 46, 0.6);
        border-radius: 5px;
        opacity: 0.6;
      }
    }
  }

  .book-card-info {
    position: relative;
    height: 199px;
    margin-left: 13px;

    .book-name {
      width: 450px;
      color: rgba(51, 51, 51, 1);
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
      white-space: nowrap;
    }

    .book-desc {
      margin-top: 11px;
      overflow: hidden;
      color: rgba(153, 153, 153, 1);
      font-size: 22px;
      line-height: 29px;
      word-break: break-word;
      .book-desc__inner {
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
      }
      ::v-deep p {
        margin: 0;
      }
      ::v-deep img {
        max-width: 100%;
        height: auto;
        vertical-align: middle;
      }
    }
    .course_discount {
      display: flex;
      flex-wrap: wrap;
      padding-top: 16px;
      span {
        height: 29px;
        padding: 0 7px;
        color: #fe9766;
        font-weight: 400;
        font-size: 18px;
        line-height: 29px;
        background: #fef5f1;
        border-radius: 5px;
      }
    }

    .book-price-info {
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: baseline;
      .courseType {
        color: rgba(255, 57, 56, 1);
        font-size: 18px;
      }
      .showPic {
        display: flex;
        align-items: flex-end;
        margin-left: 8px;
        b {
          color: #ff3938;
          font-size: 24px;
        }
        span {
          color: #ff3938;
          font-weight: 500;
          font-size: 32px;
        }
        .fontSty {
          font-size: 24px;
        }

        &--ms {
          display: flex;
          align-items: center;
          width: 223px;
          height: 54px;
          margin-left: 0;
          padding: 0 0 0 40px;
          color: #fff;
          background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/boolMall/ms-bg.png');
          background-repeat: no-repeat;
          background-position: left center;
          background-size: auto 100%;
          b,
          span {
            color: #fff;
          }
        }
      }
      s {
        padding-left: 7px;
        color: #ccc;
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
      }
    }
  }
}
</style>
